import { render, staticRenderFns } from "./ItemCardBasicDataReplacedBy.vue?vue&type=template&id=3fe67858&scoped=true"
import script from "./ItemCardBasicDataReplacedBy.vue?vue&type=script&lang=ts"
export * from "./ItemCardBasicDataReplacedBy.vue?vue&type=script&lang=ts"
import style0 from "./ItemCardBasicDataReplacedBy.vue?vue&type=style&index=0&id=3fe67858&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe67858",
  null
  
)

export default component.exports